import { get, put } from "../api";

export async function getHomepageTools() {
    return await get('tool/homepage');
}

export async function searchHomepageTools(searchType, searchValue) {
    const params = new URLSearchParams({ type: searchType, value: searchValue });
    return await get(`tool/homepage-search?${params.toString()}`);
}

export async function updateHomepageTool(publicId, values) {
    return await put(values, `tool/homepage/${publicId}`);
}
